var _defs, _circle, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e0e4e9;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #637b93;\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 106,
    cy: 81,
    r: 76.54
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 10.77,
    y: 38.09,
    width: 190.47,
    height: 102.3,
    rx: 3.96,
    ry: 3.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.33,150h84.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.59,150v-9.04h28.26v9.04h-28.26Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.57,
    y: 42.05,
    width: 9.04,
    height: 9.04,
    rx: 1.13,
    ry: 1.13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.42,
    y: 64.66,
    width: 153.17,
    height: 9.04,
    rx: 1.13,
    ry: 1.13
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.42,
    y: 83.87,
    width: 153.17,
    height: 9.04,
    rx: 1.13,
    ry: 1.13
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.42,
    y: 103.09,
    width: 153.17,
    height: 9.04,
    rx: 1.13,
    ry: 1.13
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.42,
    y: 122.31,
    width: 153.17,
    height: 9.04,
    rx: 1.13,
    ry: 1.13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.51,44.03h14.13c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54h-14.13c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.17,
    cy: 46.57,
    r: 2.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.64,44.03h14.13c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54h-14.13c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 79.29,
    cy: 46.57,
    r: 2.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.77,44.03h14.13c1.4,0,2.54,1.14,2.54,2.54h0c0,1.4-1.14,2.54-2.54,2.54h-14.13c-1.4,0-2.54-1.14-2.54-2.54h0c0-1.4,1.14-2.54,2.54-2.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.42,
    cy: 46.57,
    r: 2.54
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.33,54.48H200.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.421a0e90fe08ce466b2e265fb782ce91.svg";
export { ForwardRef as ReactComponent };